const prefersReducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
const clamp = (value, min = 0, max = 1) => Math.min(Math.max(value, min), max);
const lerp = (start, end, progress) => start + (end - start) * progress;

function notxsOpenCartDrawer(cartDrawer, responseData) {
  const drawer = cartDrawer || document.querySelector('m-cart-drawer, [data-cart-drawer]');
  if (!drawer) return;
  if (responseData && responseData.sections && typeof drawer.renderContents === 'function') {
    drawer.renderContents(responseData);
    return;
  }
  if (typeof drawer.onCartDrawerUpdate === 'function') {
    drawer.onCartDrawerUpdate();
  }
  if (typeof drawer.open === 'function') {
    drawer.open();
  }
}

if (typeof window !== 'undefined') {
  window.notxsOpenCartDrawer = notxsOpenCartDrawer;
}

function notxsInitShippingCalc(calc) {
  if (!calc || calc.dataset.notxsScReady === '1') return;
  calc.dataset.notxsScReady = '1';

  const cepInput = calc.querySelector('[data-notxs-sc-cep]');
  const btn = calc.querySelector('[data-notxs-sc-btn]');
  const errorEl = calc.querySelector('[data-notxs-sc-error]');
  const resultsEl = calc.querySelector('[data-notxs-sc-results]');
  const optionsContainer = calc.querySelector('[data-notxs-sc-options]');
  const dataTemplate = calc.querySelector('[data-notxs-sc-data]');
  const locationEl = calc.querySelector('[data-notxs-sc-location]');
  const logisticsUrl = calc.dataset.notxsScLogistics || '';

  if (!cepInput || !btn) return;

  function formatCEP(v) {
    const n = v.replace(/\D/g, '').slice(0, 8);
    return n.length > 5 ? n.slice(0, 5) + '-' + n.slice(5) : n;
  }

  function reset() {
    if (errorEl) errorEl.style.display = 'none';
    if (resultsEl) resultsEl.style.display = 'none';
    if (locationEl) locationEl.style.display = 'none';
  }

  cepInput.addEventListener('input', function () {
    this.value = formatCEP(this.value);
    reset();
  });

  function showError(msg) {
    if (errorEl) { errorEl.textContent = msg; errorEl.style.display = 'block'; }
    if (resultsEl) resultsEl.style.display = 'none';
    if (locationEl) locationEl.style.display = 'none';
  }

  function setBtnLoading(loading) {
    if (loading) {
      if (!btn.dataset.origText) btn.dataset.origText = btn.textContent.trim();
      btn.textContent = '...';
      btn.disabled = true;
    } else {
      btn.textContent = btn.dataset.origText || btn.textContent;
      btn.disabled = false;
    }
  }

  function renderOptionRow(name, desc, price, days) {
    const accentColor = getComputedStyle(calc).getPropertyValue('--notxs-sc-accent').trim() || '#111827';
    const row = document.createElement('div');
    row.style.cssText = 'display:flex;justify-content:space-between;align-items:flex-start;padding:10px 12px;border:1px solid #E5E7EB;border-radius:6px;margin-bottom:6px;background:#fff;gap:8px;';
    let left = '<div><span style="font-weight:600;font-size:13px;display:block;">' + name + '</span>';
    if (desc) left += '<span style="font-size:12px;color:#6B7280;display:block;">' + desc + '</span>';
    if (days) left += '<span style="font-size:12px;color:#6B7280;display:block;">' + days + '</span>';
    left += '</div>';
    const right = '<span style="font-weight:700;font-size:14px;white-space:nowrap;color:' + accentColor + ';flex-shrink:0;">' + (price || 'Grátis') + '</span>';
    row.innerHTML = left + right;
    return row;
  }

  function showStaticOptions() {
    if (!dataTemplate) { showError('Nenhuma opção configurada.'); return; }
    const optionEls = dataTemplate.content.querySelectorAll('[data-sc-option]');
    if (optionEls.length === 0) { showError('Nenhuma opção de frete configurada pelo administrador.'); return; }
    if (optionsContainer) optionsContainer.innerHTML = '';
    optionEls.forEach(function (opt) {
      if (optionsContainer) optionsContainer.appendChild(renderOptionRow(opt.dataset.name || '', opt.dataset.desc || '', opt.dataset.price || '', opt.dataset.days || ''));
    });
    if (resultsEl) resultsEl.style.display = 'block';
  }

  function showDynamicOptions(options) {
    if (!options || !options.length) { showError('Nenhuma opção disponível para este CEP.'); return; }
    if (optionsContainer) optionsContainer.innerHTML = '';
    options.forEach(function (opt) {
      if (optionsContainer) optionsContainer.appendChild(renderOptionRow(
        opt.name || opt.label || '',
        opt.description || opt.desc || '',
        opt.price || opt.value || '',
        opt.days || opt.delivery_time || opt.prazo || ''
      ));
    });
    if (resultsEl) resultsEl.style.display = 'block';
  }

  function calculate() {
    const cep = cepInput.value.replace(/\D/g, '');
    reset();

    if (cep.length !== 8) {
      showError('Digite um CEP válido com 8 dígitos.');
      return;
    }

    setBtnLoading(true);

    fetch('https://viacep.com.br/ws/' + cep + '/json/')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.erro === true || data.erro === 'true') {
          showError('CEP não encontrado. Verifique o número e tente novamente.');
          setBtnLoading(false);
          return;
        }

        const city = data.localidade || '';
        const state = data.uf || '';
        if (locationEl && (city || state)) {
          locationEl.textContent = 'Envio para ' + [city, state].filter(Boolean).join(' – ');
          locationEl.style.display = 'block';
        }

        if (logisticsUrl) {
          const shop = (window.Shopify || {}).shop || location.hostname;
          fetch(logisticsUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ cep: cep, city: city, state: state, shop: shop })
          })
            .then(function (r) { return r.json(); })
            .then(function (resp) {
              const opts = resp.options || resp.rates || (Array.isArray(resp) ? resp : []);
              showDynamicOptions(opts);
            })
            .catch(function () { showStaticOptions(); })
            .then(function () { setBtnLoading(false); });
        } else {
          showStaticOptions();
          setBtnLoading(false);
        }
      })
      .catch(function () {
        showError('Erro ao verificar o CEP. Verifique sua conexão e tente novamente.');
        setBtnLoading(false);
      });
  }

  btn.addEventListener('click', calculate);
  cepInput.addEventListener('keydown', function (e) { if (e.key === 'Enter') calculate(); });
}

function notxsInitAllShippingCalcs(root) {
  (root || document).querySelectorAll('[data-notxs-shipping-calc]').forEach(notxsInitShippingCalc);
}

// Registers scroll+resize listeners only while element is near the viewport.
// Falls back to always-on if IntersectionObserver is unavailable.
function notxsObserveScroll(element, onActivate, onDeactivate) {
  if (!('IntersectionObserver' in window)) {
    onActivate();
    return null;
  }
  const observer = new IntersectionObserver(
    (entries) => entries.forEach((e) => (e.isIntersecting ? onActivate() : onDeactivate())),
    { rootMargin: '300px 0px 300px 0px' }
  );
  observer.observe(element);
  return observer;
}

function calculateStickyProgress(stage, sticky) {
  if (!stage) return 0;
  const scrollY = window.scrollY || window.pageYOffset;
  const viewport = window.innerHeight || document.documentElement.clientHeight;
  const stageTop = stage.getBoundingClientRect().top + scrollY;
  const stickyOffset = sticky ? Number.parseFloat(window.getComputedStyle(sticky).top) || 0 : 0;
  const stickyHeight = sticky ? sticky.offsetHeight : viewport;
  const start = stageTop - stickyOffset;
  const end = Math.max(stageTop + stage.offsetHeight - stickyHeight - stickyOffset, start + 1);
  return clamp((scrollY - start) / (end - start));
}

function calculateExpandingRevealProgress(tracker) {
  if (!tracker) return 0;
  const rect = tracker.getBoundingClientRect();
  const viewport = window.innerHeight || document.documentElement.clientHeight;
  const travel = Math.max(rect.height + viewport, 1);
  return clamp((viewport - rect.top) / travel);
}

class NotxsParallaxBanner extends HTMLElement {
  connectedCallback() {
    this.media = this.querySelector('[data-notxs-parallax-media]');
    this.strength = Number(this.dataset.parallaxStrength || 100) / 100;
    this.travel = Number(this.dataset.parallaxTravel || 0) * this.strength;
    this.direction = this.dataset.parallaxDirection || 'normal';
    this.ticking = false;
    this.update = this.update.bind(this);
    this.onScroll = this.onScroll.bind(this);
    this.onScroll();
    this._scrollObserver = notxsObserveScroll(
      this,
      () => {
        this.onScroll();
        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onScroll);
      },
      () => {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
      }
    );
  }

  disconnectedCallback() {
    if (this._scrollObserver) this._scrollObserver.disconnect();
    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.onScroll);
  }

  onScroll() {
    if (this.ticking) return;
    this.ticking = true;
    requestAnimationFrame(this.update);
  }

  update() {
    this.ticking = false;
    if (!this.media) return;
    if (prefersReducedMotion() || this.travel <= 0) {
      this.media.style.transform = 'translate3d(0, 0, 0)';
      return;
    }

    const scrollY = window.scrollY || window.pageYOffset;
    const viewport = window.innerHeight || document.documentElement.clientHeight;
    const rect = this.getBoundingClientRect();
    const elementTop = rect.top + scrollY;
    const start = elementTop - viewport;
    const end = elementTop + rect.height;
    const progress = clamp((scrollY - start) / (end - start));
    const normalTranslate = lerp(0, this.travel, progress);
    const reverseTranslate = lerp(0, -this.travel, progress);
    const translate = this.direction === 'reverse' ? reverseTranslate : normalTranslate;
    this.media.style.transform = `translate3d(0, ${translate}px, 0)`;
  }
}

class NotxsScrollStory extends HTMLElement {
  connectedCallback() {
    this.stage = this.querySelector('[data-notxs-scroll-story-stage]');
    this.sticky = this.querySelector('[data-notxs-scroll-story-sticky]');
    this.viewport = this.querySelector('[data-notxs-scroll-story-viewport]');
    this.track = this.querySelector('[data-notxs-scroll-story-track]');
    this.items = [...this.querySelectorAll('[data-notxs-scroll-story-item]')];
    this.mode = this.dataset.effectMode || 'fade';
    this.mobileLayout = this.dataset.mobileLayout || 'stack';
    this.horizontalActiveIndex = -1;
    this.horizontalConfiguredDistance = 0;
    this.horizontalMaxTranslate = 0;
    this.horizontalScrollLength = 0;
    this.horizontalStep = 0;
    this.ticking = false;
    this.update = this.update.bind(this);
    this.measureHorizontalStage = this.measureHorizontalStage.bind(this);
    this.updateHorizontalStage = this.updateHorizontalStage.bind(this);
    this.applyHorizontalCardWidth = this.applyHorizontalCardWidth.bind(this);
    this.ensureHorizontalOverflow = this.ensureHorizontalOverflow.bind(this);
    this.setActiveHorizontalItem = this.setActiveHorizontalItem.bind(this);
    this.onResize = this.onResize.bind(this);
    this.onScroll = this.onScroll.bind(this);
    this.boundHorizontalImages = [];
    this.measureHorizontalStage();
    requestAnimationFrame(() => this.measureHorizontalStage());
    if ('ResizeObserver' in window) {
      this.resizeObserver = new ResizeObserver(this.onResize);
      if (this.viewport) this.resizeObserver.observe(this.viewport);
      if (this.track) this.resizeObserver.observe(this.track);
    }
    this.querySelectorAll('img').forEach((image) => {
      this.boundHorizontalImages.push(image);
      image.addEventListener('load', this.onResize);
      image.addEventListener('error', this.onResize);
    });
    this.onScroll();
    this._scrollObserver = notxsObserveScroll(
      this,
      () => {
        this.onScroll();
        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onResize);
      },
      () => {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onResize);
      }
    );
  }

  disconnectedCallback() {
    if (this._scrollObserver) this._scrollObserver.disconnect();
    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.onResize);
    if (this.resizeObserver) this.resizeObserver.disconnect();
    this.boundHorizontalImages.forEach((image) => {
      image.removeEventListener('load', this.onResize);
      image.removeEventListener('error', this.onResize);
    });
  }

  onResize() {
    this.measureHorizontalStage();
    this.onScroll();
  }

  onScroll() {
    if (this.ticking) return;
    this.ticking = true;
    requestAnimationFrame(this.update);
  }

  update() {
    this.ticking = false;
    if (!this.track || !this.stage) return;
    const reduceMotion = prefersReducedMotion();

    // On mobile the effect only runs when the merchant chose the "carousel"
    // (same-as-desktop) layout; stack/grid are static there.
    const disabledOnMobile = window.innerWidth < 750 && this.mobileLayout !== 'carousel';
    if (this.mode === 'stack' || disabledOnMobile) {
      this.track.style.transform = '';
      this.items.forEach((item) => {
        item.classList.remove('is-active', 'is-before', 'is-after');
      });
      return;
    }

    if (reduceMotion && this.mode !== 'horizontal') return;

    const progress = calculateStickyProgress(this.stage, this.sticky);

    if (this.mode === 'horizontal') {
      const translateX = this.horizontalMaxTranslate * progress;
      const activeIndex = this.horizontalStep > 0 ? Math.round(translateX / this.horizontalStep) : 0;
      this.track.style.transform = `translate3d(${-translateX}px, 0, 0)`;
      this.style.setProperty('--notxs-horizontal-progress', String(progress));
      this.setActiveHorizontalItem(activeIndex);
      return;
    }

    if (this.mode === 'fade') {
      const count = Math.max(this.items.length, 1);
      const activeIndex = Math.min(count - 1, Math.floor(progress * count));
      this.items.forEach((item, index) => {
        item.classList.toggle('is-active', index === activeIndex);
        item.classList.toggle('is-before', index < activeIndex);
        item.classList.toggle('is-after', index > activeIndex);
      });
    }
  }

  updateHorizontalStage() {
    this.measureHorizontalStage();
  }

  measureHorizontalStage() {
    if (!this.track || !this.viewport || this.mode !== 'horizontal') return;
    // On mobile, only the "carousel" layout runs the pinned effect. For stack/grid
    // reset the inline stage height so the layout can flow naturally.
    if (window.innerWidth < 750 && this.mobileLayout !== 'carousel') {
      if (this.stage) this.stage.style.height = '';
      this.style.setProperty('--notxs-horizontal-overflow', '0px');
      return;
    }
    const viewportWidth = this.viewport.clientWidth || this.clientWidth;
    if (viewportWidth <= 0) return;
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    const stickyHeight = this.sticky ? this.sticky.offsetHeight : viewportHeight;
    const rootStyles = window.getComputedStyle(this);
    const trackStyles = window.getComputedStyle(this.track);
    const gap = Number.parseFloat(trackStyles.columnGap || trackStyles.gap) || 0;
    const configuredCardWidth = Number.parseFloat(rootStyles.getPropertyValue('--notxs-card-width')) || viewportWidth;
    let cardWidth = Math.min(configuredCardWidth, viewportWidth);

    this.applyHorizontalCardWidth(cardWidth);
    this.horizontalMaxTranslate = Math.max(this.track.scrollWidth - viewportWidth, 0);
    cardWidth = this.ensureHorizontalOverflow(cardWidth, viewportWidth);
    this.horizontalStep = cardWidth + gap;
    this.horizontalMaxTranslate = Math.max(this.track.scrollWidth - viewportWidth, 0);
    this.horizontalConfiguredDistance = Number.parseFloat(rootStyles.getPropertyValue('--notxs-scroll-distance')) || viewportHeight;
    this.horizontalScrollLength = Math.max(this.horizontalConfiguredDistance, this.horizontalMaxTranslate);

    if (this.stage) {
      this.stage.style.height = `${stickyHeight + this.horizontalScrollLength}px`;
    }
    this.style.setProperty('--notxs-horizontal-overflow', `${this.horizontalScrollLength}px`);
  }

  applyHorizontalCardWidth(cardWidth) {
    this.track.style.setProperty('--notxs-card-width', `${cardWidth}px`);
    this.items.forEach((item) => {
      item.style.setProperty('--notxs-card-width', `${cardWidth}px`);
    });
  }

  ensureHorizontalOverflow(cardWidth, viewportWidth) {
    if (this.horizontalMaxTranslate > 1 || this.items.length <= 1) return cardWidth;
    const expandedCardWidth = Math.min(viewportWidth, Math.max(cardWidth, viewportWidth * 0.78));
    if (expandedCardWidth === cardWidth) return cardWidth;
    this.applyHorizontalCardWidth(expandedCardWidth);
    this.horizontalMaxTranslate = Math.max(this.track.scrollWidth - viewportWidth, 0);
    return expandedCardWidth;
  }

  setActiveHorizontalItem(index) {
    if (!this.items.length) return;
    const activeIndex = clamp(index, 0, this.items.length - 1);
    if (this.horizontalActiveIndex === activeIndex) return;
    this.horizontalActiveIndex = activeIndex;
    this.items.forEach((item, itemIndex) => {
      item.classList.toggle('is-active', itemIndex === activeIndex);
      item.classList.toggle('is-before', itemIndex < activeIndex);
      item.classList.toggle('is-after', itemIndex > activeIndex);
    });
  }
}

class NotxsExpandingReveal extends HTMLElement {
  connectedCallback() {
    this.stage = this.querySelector('[data-notxs-expanding-stage]');
    this.scroller = this.querySelector('[data-notxs-expanding-scroller]');
    this.revealTargets = this.querySelectorAll('.notxs-expanding-reveal__image-clipper, .notxs-expanding-reveal__content--inside');
    this.mediaTargets = this.querySelectorAll('.notxs-expanding-reveal__image, .notxs-expanding-reveal__placeholder');
    this.scrollDistance = Number(this.dataset.scrollDistance || 0);
    this.revealStart = Number(this.dataset.revealStart || 0) / 100;
    this.revealEnd = Number(this.dataset.revealEnd || 80) / 100;
    this.ticking = false;
    this.update = this.update.bind(this);
    this.syncTrackerHeight = this.syncTrackerHeight.bind(this);
    this.onScroll = this.onScroll.bind(this);
    this.syncTrackerHeight();
    requestAnimationFrame(() => this.syncTrackerHeight());
    if ('ResizeObserver' in window && this.scroller) {
      this.resizeObserver = new ResizeObserver(this.syncTrackerHeight);
      this.resizeObserver.observe(this.scroller);
    }
    this.querySelectorAll('img').forEach((image) => {
      image.addEventListener('load', this.syncTrackerHeight, { once: true });
      image.addEventListener('error', this.syncTrackerHeight, { once: true });
    });
    this.onScroll();
    this._scrollObserver = notxsObserveScroll(
      this,
      () => {
        this.onScroll();
        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onScroll);
        window.addEventListener('resize', this.syncTrackerHeight);
      },
      () => {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
        window.removeEventListener('resize', this.syncTrackerHeight);
      }
    );
  }

  disconnectedCallback() {
    if (this._scrollObserver) this._scrollObserver.disconnect();
    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.onScroll);
    window.removeEventListener('resize', this.syncTrackerHeight);
    if (this.resizeObserver) this.resizeObserver.disconnect();
  }

  getScrollDistance() {
    return this.scrollDistance || Number.parseFloat(getComputedStyle(this).getPropertyValue('--notxs-expanding-scroll-distance')) || 0;
  }

  syncTrackerHeight() {
    if (!this.stage || !this.scroller) return;
    const distance = this.getScrollDistance();
    const totalHeight = this.scroller.clientHeight + distance;
    this.stage.style.height = `${totalHeight}px`;
    this.style.setProperty('--notxs-expanding-total-height', `${totalHeight}px`);
  }

  onScroll() {
    if (this.ticking) return;
    this.ticking = true;
    requestAnimationFrame(this.update);
  }

  update() {
    this.ticking = false;
    if (!this.stage) return;
    if (prefersReducedMotion()) {
      this.style.setProperty('--notxs-reveal-progress', '1');
      this.style.setProperty('--notxs-reveal-image-clip', 'inset(0 0 0 0)');
      this.style.setProperty('--notxs-reveal-image-transform', 'translate(0, 0) scale(1)');
      this.revealTargets.forEach((target) => {
        target.style.clipPath = 'inset(0 0 0 0)';
      });
      this.mediaTargets.forEach((target) => {
        target.style.transform = 'translate(0, 0) scale(1)';
      });
      return;
    }

    const progress = calculateExpandingRevealProgress(this.stage);
    const revealRange = Math.max(this.revealEnd - this.revealStart, 0.01);
    const revealProgress = clamp((progress - this.revealStart) / revealRange);
    const contentProgress = clamp(revealProgress / 0.25);
    const revealTop = lerp(37, 0, revealProgress);
    const revealSide = lerp(37, 0, revealProgress);
    const revealBottom = lerp(41, 0, revealProgress);
    const revealClip = `inset(${revealTop}% ${revealSide}% ${revealBottom}% ${revealSide}%)`;
    const imageX = lerp(-10, 0, revealProgress);
    const imageY = lerp(-1.5, 0, revealProgress);
    const imageScale = lerp(1.4, 1, revealProgress);
    const imageTransform = `translate(${imageX}%, ${imageY}%) scale(${imageScale})`;

    this.style.setProperty('--notxs-reveal-progress', String(contentProgress));
    this.style.setProperty('--notxs-reveal-image-clip', revealClip);
    this.style.setProperty('--notxs-reveal-image-transform', imageTransform);
    this.revealTargets.forEach((target) => {
      target.style.clipPath = revealClip;
    });
    this.mediaTargets.forEach((target) => {
      target.style.transform = imageTransform;
    });
  }
}

class NotxsImagesTextScrolling extends HTMLElement {
  connectedCallback() {
    this.mainImage = this.querySelector('.notxs-images-scrolling-desktop__media-wrapper > :first-child');
    this.imageToTransitionItems = [...this.querySelectorAll('.notxs-images-scrolling-desktop__media-wrapper > :not(:first-child)')];
    this.mediaItems = [...this.querySelectorAll('[data-notxs-images-media]')];
    this.contentItems = [...this.querySelectorAll('[data-notxs-images-content]')];
    this.scrollingExperience = this.getAttribute('scrolling-experience') || 'reveal';
    this.ticking = false;
    this.update = this.update.bind(this);
    this.onScroll = this.onScroll.bind(this);

    if (!this.hasAttribute('scrolling-experience') || !this.mainImage || this.contentItems.length === 0) return;

    this.onScroll();
    this._scrollObserver = notxsObserveScroll(
      this,
      () => {
        this.onScroll();
        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onScroll);
      },
      () => {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
      }
    );
  }

  disconnectedCallback() {
    if (this._scrollObserver) this._scrollObserver.disconnect();
    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.onScroll);
  }

  onScroll() {
    if (this.ticking) return;
    this.ticking = true;
    requestAnimationFrame(this.update);
  }

  update() {
    this.ticking = false;
    if (!this.mainImage || prefersReducedMotion()) return;

    const mediaRect = this.mainImage.getBoundingClientRect();
    const switchLine = mediaRect.top + mediaRect.height * 0.55;
    let activeIndex = 0;

    this.contentItems.forEach((contentItem, index) => {
      const rect = contentItem.getBoundingClientRect();
      if (rect.top <= switchLine && rect.bottom > mediaRect.top + mediaRect.height * 0.15) {
        activeIndex = index;
      }
    });

    this.contentItems.forEach((contentItem, index) => {
      contentItem.classList.toggle('is-active', index === activeIndex);
    });

    this.mediaItems.forEach((mediaItem, index) => {
      const isVisible = index <= activeIndex;
      mediaItem.classList.toggle('is-visible', isVisible);
      if (this.scrollingExperience === 'fade') {
        mediaItem.style.zIndex = index === activeIndex ? String(index + 2) : String(index + 1);
        mediaItem.style.opacity = index === activeIndex ? '1' : '0';
      } else {
        mediaItem.style.zIndex = String(index + 1);
        mediaItem.style.opacity = isVisible ? '1' : '0';
      }
    });
  }
}

if (!customElements.get('notxs-parallax-banner')) {
  customElements.define('notxs-parallax-banner', NotxsParallaxBanner);
}

if (!customElements.get('notxs-scroll-story')) {
  customElements.define('notxs-scroll-story', NotxsScrollStory);
}

if (!customElements.get('notxs-expanding-reveal')) {
  customElements.define('notxs-expanding-reveal', NotxsExpandingReveal);
}

if (!customElements.get('notxs-images-text-scrolling')) {
  customElements.define('notxs-images-text-scrolling', NotxsImagesTextScrolling);
}

if (!window.notxsCommerceBlocksBound) {
  window.notxsCommerceBlocksBound = true;

  // Initialize shipping calculators on load and on section/block updates in editor
  document.addEventListener('DOMContentLoaded', () => notxsInitAllShippingCalcs());
  document.addEventListener('shopify:section:load', (e) => notxsInitAllShippingCalcs(e.target));
  document.addEventListener('shopify:block:select', (e) => notxsInitAllShippingCalcs(e.target.closest('.shopify-section') || document));

  // Variant price update
  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-notxs-variant-select]');
    if (!select) return;
    const form = select.closest('[data-notxs-product-form]');
    const price = form && form.querySelector('[data-notxs-price]');
    const selected = select.options[select.selectedIndex];
    if (price && selected && selected.dataset.price) {
      price.textContent = selected.dataset.price;
    }
  });

  // Dialog and sibling upsell controls
  document.addEventListener('click', (event) => {
    const sizeGuideOpen = event.target.closest('[data-notxs-size-guide-open]');
    if (sizeGuideOpen) {
      const dialogId = sizeGuideOpen.dataset.notxsSizeGuideOpen || sizeGuideOpen.getAttribute('aria-controls');
      const dialog = dialogId ? document.getElementById(dialogId) : null;
      if (dialog && typeof dialog.showModal === 'function') {
        dialog.showModal();
      } else if (dialog) {
        dialog.setAttribute('open', '');
      }
      return;
    }

    const sizeGuideClose = event.target.closest('[data-notxs-size-guide-close]');
    if (sizeGuideClose) {
      const dialog = sizeGuideClose.closest('[data-notxs-size-guide-dialog]');
      if (dialog && typeof dialog.close === 'function') {
        dialog.close();
      } else if (dialog) {
        dialog.removeAttribute('open');
      }
      return;
    }

    const sizeGuideDialog = event.target.closest('[data-notxs-size-guide-dialog]');
    if (sizeGuideDialog && event.target === sizeGuideDialog) {
      if (typeof sizeGuideDialog.close === 'function') {
        sizeGuideDialog.close();
      } else {
        sizeGuideDialog.removeAttribute('open');
      }
      return;
    }

    const opener = event.target.closest('[data-notxs-sibling-open]');
    if (opener) {
      const dialog = document.getElementById(opener.dataset.notxsSiblingOpen);
      if (dialog && typeof dialog.showModal === 'function') {
        dialog.showModal();
      }
      return;
    }

    const closer = event.target.closest('[data-notxs-sibling-close]');
    if (closer) {
      const dialog = closer.closest('[data-notxs-sibling-dialog]');
      if (dialog) dialog.close();
      return;
    }

    const dialog = event.target.closest('[data-notxs-sibling-dialog]');
    if (dialog && event.target === dialog) {
      dialog.close();
    }
  });

  // Add-to-cart handler — works in both storefront and theme editor
  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-notxs-product-form]');
    if (!form) return;
    event.preventDefault();

    const message = form.querySelector('[data-notxs-form-message]');
    const button = form.querySelector('[data-notxs-submit]');
    const actionMode = form.dataset.actionMode || 'cart';

    if (actionMode === 'product') {
      window.location.href = form.dataset.productUrl;
      return;
    }

    if (form.dataset.productAvailable === 'false') {
      if (message) message.textContent = 'Produto esgotado.';
      return;
    }

    const variantField = form.querySelector('[data-notxs-variant-id]');
    const variantId = variantField ? Number.parseInt(variantField.value, 10) : 0;
    if (!variantId) {
      if (message) message.textContent = 'Selecione uma opção.';
      return;
    }

    const quantityField = form.querySelector('[name="quantity"]');
    const quantity = quantityField ? Number.parseInt(quantityField.value, 10) || 1 : 1;

    if (button) button.disabled = true;
    if (message) message.textContent = '';

    const cartDrawer = document.querySelector('m-cart-drawer, [data-cart-drawer]');
    const addUrl = '/cart/add.js';

    const body = { id: variantId, quantity };
    if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
      body.sections = cartDrawer.getSectionsToRender().map((s) => s.id).join(',');
      body.sections_url = window.location.pathname;
    }

    try {
      const response = await fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      });

      const responseData = await response.json().catch(() => ({}));

      if (responseData.status || !response.ok) {
        throw new Error(responseData.description || responseData.message || 'Não foi possível adicionar ao carrinho.');
      }

      if (actionMode === 'checkout') {
        window.location.href = '/checkout';
        return;
      }

      if (message) message.textContent = 'Produto adicionado.';

      // Open cart drawer (supports any theme's drawer implementation)
      notxsOpenCartDrawer(cartDrawer, responseData);

      // Dispatch standard cart update event consumed by most Shopify themes
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { item: responseData } }));
    } catch (error) {
      if (message) message.textContent = error.message;
    } finally {
      if (button) button.disabled = false;
    }
  });
}

// Auto-init shipping calcs already in DOM on script load (before DOMContentLoaded)
notxsInitAllShippingCalcs();
